module.exports = __webpack_public_path__ + "static/img/point-font-text@t.ebfd9ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-group/point-font-text@t.png
// module id = Jg6Y
// module chunks = 0